import { type Ref, ref } from 'vue'

export interface UseModalOptions<T> {
  onOpen?: (data?: T) => void
  onClose?: () => void
}

export function useModal<T = void>(options?: UseModalOptions<T>) {
  const isOpen = ref(false)
  const data = ref<T | null>(null) as Ref<T | null>

  /** Открывает модалку */
  const open = (modalData?: T) => {
    data.value = modalData ?? null
    isOpen.value = true
    options?.onOpen?.(modalData)
  }

  /** Закрывает модалку */
  const close = () => {
    isOpen.value = false
    const previousData = data.value
    data.value = null
    options?.onClose?.()
    return previousData
  }

  return {
    isOpen,
    data,
    open,
    close,
  }
}
